import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/registration')({
  component: PreRegistrationLayout,
});

function PreRegistrationLayout() {
  return <Outlet />;
}
